import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {ConfigService} from '../utils/config.service';
import { ConfigParamsService } from '../configParameters/config-params.service';

@Injectable()
export class MapService {
  private getFeaturesURL = `${environment.API}${environment.RESOURCES.FEATURES}`;
  private privateFileName = 'private_layers.config';
  private publicFileName = 'public_layers.config';
  private configFileLayerToGet: string = '';
  private featureSelected: ol.Feature;

  constructor(private http: HttpClient, private configService: ConfigService, protected configParamsService: ConfigParamsService) {
    this.getFeaturesURL = `${configService.getBaseApiUrl}${environment.RESOURCES.FEATURES}`;
    this.configFileLayerToGet = this.configParamsService.isPrivateApp() ? this.privateFileName : this.publicFileName;
  }

  public setSelectedFeature(features) {
    this.featureSelected = features;
  }

  getFeatures(layerName, username): Promise<Object> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.getFeaturesURL, { "layerName":layerName, "configFile":this.configFileLayerToGet, "username":username}, {headers: headers})
      .toPromise()
      .then(response => {
        if (response) {
          return response;
        } else {
          return {};
        }
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/services/map/map.service.ts